const api_url = process.env.NODE_ENV ===  "development" ? "http://localhost:8000/api/v1" : "https://api.bsf5050.com/api/v1" ;
export default api_url;
